// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"95a2191f","681":"c8de94c3","743":"e5bfbc31"}[chunkId] + ".chunk.css";
};